import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import styled from "styled-components";
import { StickerButton } from "../../globalStyles";
import mascot from "../../images/basakansoft.png";

const RECRUITING_URL = "https://recruiting.basakansoft.com";

const Band = styled.section`
  position: relative;
  overflow: hidden;
  background: var(--primary-400);
  color: var(--text-primary);
`;

const Inner = styled.div`
  position: relative;
  width: 100%;
  max-width: var(--max-width);
  margin: 0 auto;
  padding: clamp(3.5rem, 8vw, 6rem) var(--space-6);
  display: grid;
  grid-template-columns: minmax(0, 1fr) 260px;
  gap: var(--space-8);
  align-items: center;

  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr;
    padding-bottom: 9rem;
  }
`;

const Heading = styled.h2`
  max-width: 16ch;
  font-size: clamp(2rem, 4.5vw, 3.5rem);
  font-weight: var(--font-weight-black);
  line-height: 1.12;
  letter-spacing: -0.04em;
  word-break: keep-all;
  text-wrap: balance;
`;

const Sub = styled.p`
  margin-top: var(--space-4);
  max-width: 32rem;
  font-size: 1.0625rem;
  line-height: 1.7;
  font-weight: var(--font-weight-medium);
  color: var(--brand-dark);
  word-break: keep-all;
`;

const Action = styled.div`
  margin-top: var(--space-8);
`;

/* 마스코트가 띠 아래에서 빼꼼 올라온다 */
const Mascot = styled.img`
  width: 260px;
  height: auto;
  align-self: end;
  margin-bottom: -6rem;
  transform: rotate(8deg);
  user-select: none;

  @media screen and (max-width: 768px) {
    position: absolute;
    right: 0.5rem;
    bottom: -2.5rem;
    width: 170px;
  }
`;

const CareersCTA = () => {
  const [language, setLanguage] = useState("ko");
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === "/en") setLanguage("en");
    else if (location.pathname === "/ko") setLanguage("ko");
    else setLanguage(localStorage.getItem("language") || "ko");

    const handleLanguageChange = (e) => setLanguage(e.detail);
    window.addEventListener("languageChange", handleLanguageChange);
    return () =>
      window.removeEventListener("languageChange", handleLanguageChange);
  }, [location.pathname]);

  const content = {
    ko: {
      heading: "바삭한소프트와 함께 성장하실래요?",
      sub: "위대한 여정을 함께할 열정적인 동료를 기다립니다.",
      button: "채용 살펴보기",
    },
    en: {
      heading: "Want to grow with Basakansoft?",
      sub: "We're looking for passionate teammates to join the journey.",
      button: "Explore careers",
    },
  };

  const c = content[language];

  return (
    <Band id="careers">
      <Inner>
        <div>
          <Heading>{c.heading}</Heading>
          <Sub>{c.sub}</Sub>
          <Action>
            <StickerButton href={RECRUITING_URL} target="_blank" rel="noreferrer">
              {c.button}
            </StickerButton>
          </Action>
        </div>
        <Mascot src={mascot} alt="" aria-hidden="true" />
      </Inner>
    </Band>
  );
};

export default CareersCTA;
